import {EntityBase} from "../../../shared/entity/EntityBase";

const MERGE_EVENT_MASTER_TABLE_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    mergeEventType: { type: Number, defaultValue: 1 },
    openLevel: { type: Number, defaultValue: 1 },
    name: { defaultValue: '' },
}

export class MergeEventMasterTableEntity extends EntityBase {
    constructor(data = {}) {
        super(data, MERGE_EVENT_MASTER_TABLE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }
}